module.exports = __webpack_public_path__ + "img/zhaohang3.6897a381.png";